'use strict';

import SearchRoutePoint from './SearchRoutePoint';
import SearchRouteTime from './SearchRouteTime';
import SearchRouteDate from "./SearchRouteDate";

export default class SearchRoute extends React.Component {
    constructor(props) {
        super(props);
    }

    changePoint(direction, point) {
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        route[direction] = point;
        onChangeRoute(index, route)
    }

    changeDate(date) {
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        route.date = date;
        onChangeRoute(index, route)
    }

    changeTime(time) {
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        route.time = time;
        onChangeRoute(index, route)
    }

    changeSeats(e, direction) {
        e.preventDefault();
        const {index, onChangeRoute} = this.props;
        let route = {...this.props.route};
        let seats = route.seats;
        if(direction === 'down') {
            seats = Math.max(1, seats - 1);
        } else {
            seats++;
        }
        route.seats = seats;
        onChangeRoute(index, route)
    }

    swapRoute() {
        const {index, onChangeRoute} = this.props;
        let route = {
            ...this.props.route,
            from: this.props.route.to,
            to: this.props.route.from,
        };
        onChangeRoute(index, route)
    }

    render() {
        const {type, index, route, errors, airports, dropDownParent, onRemove, onSearch, onFocus, dateRange, onlyAirports, maxAirports} = this.props;

        const showTime = ['planes', 'plane', 'sharing'].includes(type);
        const showSeats = ['planes', 'plane'].includes(type);

        return <div className={cn("search-group", route.from.id && route.to.id && 'hasSwap')}>
            {index > 0 && <a href='#' className="search-group__remove" onClick={e => onRemove(e, index)}/>}
            <div className="search-row">
                <div className="search-col" style={{flex: 1}}>
                    <SearchRoutePoint
                        index={index}
                        label={__('search.from')}
                        direction={'from'}
                        airports={airports}
                        point={route.from}
                        error={errors.includes('from')}
                        dropDownParent={dropDownParent}
                        maxAirports={maxAirports}
                        onlyAirports={onlyAirports}
                        onFocus={() => onFocus && onFocus()}
                        onSelect={point => this.changePoint('from', point)}
                    />
                    {route.from.id && route.to.id && <a className="direction-switch" onClick={() => this.swapRoute()}>
                        <i className="icon-arrow"/>
                    </a>}
                </div>
                <div className="search-col" style={{flex: 1}}>
                    <SearchRoutePoint
                        index={index}
                        label={__('search.to')}
                        direction={'to'}
                        airports={airports}
                        point={route.to}
                        error={errors.includes('to')}
                        dropDownParent={dropDownParent}
                        maxAirports={maxAirports}
                        onlyAirports={onlyAirports}
                        onSelect={point => this.changePoint('to', point)}
                        onFocus={() => onFocus && onFocus()}
                    />
                </div>
                <div className="search-col">
                    <SearchRouteDate
                        value={route.date}
                        hasError={errors.includes('date')}
                        isRange={dateRange}
                        onFocus={() => onFocus && onFocus()}
                        onChange={(date) => this.changeDate(date)}
                    />
                </div>
                {showTime && <div className="search-col">
                    <SearchRouteTime
                        index={index}
                        value={route.time}
                        error={errors.includes('time')}
                        onSelect={time => this.changeTime(time)}
                        onFocus={() => onFocus && onFocus()}
                    />
                </div>}
                {showSeats && <div className="search-col">
                    <div className={clsx('search-inputbox search-count', {error: errors.includes('seats')})}>
                        <div className={clsx('search-spinner', {changed: route.seats > 0})}>
                            <i className="icon-people"></i>
                            <input type="text" className="search-spinner__input" value={route.seats} onFocus={() => onFocus && onFocus()} readOnly/>
                            <span>
                                <a href='#' className="search-spinner__down" onClick={e => this.changeSeats(e, 'down')}></a>
                                <a href='#' className="search-spinner__up" onClick={e => this.changeSeats(e, 'up')}></a>
                            </span>
                        </div>
                    </div>
                </div>}
                {type === 'seats' && <button className="search-button button-search" onClick={() => onSearch()}>{__('search.search')}</button>}
            </div>
            {!showTime && <SearchRouteTime
                index={index}
                value={route.time}
                error={errors.includes('time')}
                hidden={true}
                onSelect={time => this.changeTime(time)}
                onFocus={() => onFocus && onFocus()}
            />}
        </div>
    }
}